import { Controller, useFormContext } from 'react-hook-form';
import { Autocomplete, TextField, FormHelperText, FormControl } from '@mui/material';
import { Options } from '../../CompanycodeTranslation/types';

interface RHFAutoProps {
  name: string;
  label: string;
  value?: any;
  options?: Options[];
  disabled?: boolean;
}

const RHFAutocomplete = ({ name, label, options = [], disabled, value }: RHFAutoProps) => {
  const { control } = useFormContext();

  // Normalize options: allow strings or objects
  const normalizedOptions: Options[] = options.map((opt: any) => (typeof opt === 'string' ? { label: opt, value: opt } : opt));

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const selectedOption = normalizedOptions.find((o) => o.value === value || field.value) || null;

        return (
          <FormControl fullWidth error={!!fieldState.error}>
            <Autocomplete
              options={normalizedOptions}
              value={selectedOption} // ✅ controlled value
              disabled={disabled}
              getOptionLabel={(opt) => opt.label ?? ''}
              onChange={(_, newValue) => {
                field.onChange(newValue?.value ?? '');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={label}
                  size="small"
                  error={!!fieldState.error}
                  sx={{
                    '& .MuiInputLabel-asterisk': {
                      color: 'red !important',
                    },
                  }}
                />
              )}
            />
            {fieldState.error && <FormHelperText>{fieldState.error.message}</FormHelperText>}
          </FormControl>
        );
      }}
    />
  );
};

export default RHFAutocomplete;
